export default "__VITE_PUBLIC_ASSET__6fed04f1__"